import React from "react";
import PropTypes from "prop-types";
import NumberFormat from 'react-number-format';
import TextField from "./TextField";

const NumberFormatRegular = React.forwardRef((props, ref) => {
  let rawValue = props.value;
  const { onChange, onBlur, noconvert, ...other } = props;

  return (
    <NumberFormat
      getInputRef={ref}
      onValueChange={values => {
        const realValue = values.value ? noconvert ? values.value : (other.decimalScale ? parseFloat(values.value) : parseInt(values.value, 10)) : '';
        if (realValue !== rawValue) { //TODO: Revisar, ya que aún que no generar el error, tiene un comportamiento extraño
          rawValue = values.value;
          onChange({
            target: {
              value: realValue
            }
          });
        }
      }}
      onBlur={() => {
        onBlur({
          target: {
            value: rawValue
          }
        });
      }}
      allowNegative={false}
      {...other}
    />
  )
});

const NumberField = React.forwardRef((props, ref) => {
  const { formatter, ...others } = props;
  return <TextField
    {...others}
    ref={ref}
    InputProps={{
      inputComponent: NumberFormatRegular,
      inputProps: { ...formatter },
    }} />;
});

NumberField.propTypes = {
  formatter: PropTypes.object,
};

NumberField.defaultProps = {

};

NumberField.displayName = 'NumberField';

export default NumberField;